'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const generateId = require('../../utils/generateId.js');
const useIsomorphicLayoutEffect = require('../hooks/useIsomorphicLayoutEffect.js');
const scrollLock_style = require('./scrollLock.style.js');

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var CLASS_NAME_PREFIX = 'mlb-scroll-lock-';
var ScrollLock = function ScrollLock(_ref) {
  var _document;
  var _ref$element = _ref.element,
    element = _ref$element === void 0 ? (_document = document) === null || _document === void 0 ? void 0 : _document.body : _ref$element;
  var className = React.useMemo(function () {
    return generateId(CLASS_NAME_PREFIX);
  }, [element]);
  var _useState = React.useState(),
    _useState2 = _slicedToArray(_useState, 2),
    styles = _useState2[0],
    setStyles = _useState2[1];
  useIsomorphicLayoutEffect.useLayoutEffect(function () {
    if (!element) {
      return;
    }

    // Feature detect overscroll-behavior css
    var isOverscrollBehaviorSupported = typeof CSS !== 'undefined' && CSS.supports('overscroll-behavior', 'contain');

    // Detect if element is document body
    var elementIsDocumentBody = element === document.body;

    // Retain original values
    var offsetX = elementIsDocumentBody ? window.pageXOffset : element.scrollLeft;
    var offsetY = elementIsDocumentBody ? window.pageYOffset : element.scrollTop;
    setStyles({
      "class": className,
      isOverscrollBehaviorSupported: isOverscrollBehaviorSupported,
      left: offsetX,
      top: offsetY,
      elementIsDocumentBody: elementIsDocumentBody
    });
    element.classList.add(className);
    return function () {
      element.classList.remove(className);
      if (!isOverscrollBehaviorSupported) {
        // Restore scroll
        if (elementIsDocumentBody) {
          window.scrollTo(offsetX, offsetY);
        } else {
          element.scrollLeft = offsetX;
          element.scrollTop = offsetY;
        }
      }
    };
  }, [element, className]);
  if (!element || !styles) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(scrollLock_style.GlobalStyles, styles);
};

exports.CLASS_NAME_PREFIX = CLASS_NAME_PREFIX;
exports.default = ScrollLock;
